var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"elementRef",class:_vm.className,style:({
        opacity: _vm.inView ? 1 : _vm.initialOpacity,
        transition: `opacity ${_vm.duration}ms ${_vm.easing}, filter ${_vm.duration}ms ${_vm.easing}`,
        filter: _vm.blur ? (_vm.inView ? 'blur(0px)' : 'blur(10px)') : 'none',
    })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }